module.exports = __webpack_public_path__ + "static/media/48254005_2309077972500714_5492815897984761856_o.83f80f15.jpg";